(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const addUrl = root + 'cart/add.js';
  const updateUrl = root + 'cart/update.js';
  const cartUrl = root + 'cart.js';
  let upsellAdding = false;

  function getCart() {
    return fetch(cartUrl).then(function (r) { return r.json(); });
  }

  async function addVariant(id, uncertainMessage, rejectedMessage) {
    let res;
    try {
      res = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: 1 }],
          sections: 'cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer',
          sections_url: window.location.pathname
        })
      });
    } catch {
      throw new Error(uncertainMessage);
    }
    let data;
    try { data = await res.json(); } catch { throw new Error(res.ok ? uncertainMessage : rejectedMessage); }
    if (!res.ok || (data.status && data.status >= 400)) {
      throw new Error(data.description || data.message || rejectedMessage);
    }
    return data;
  }

  async function applyDiscount(code) {
    const res = await fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: String(code || '') })
    });
    const data = await res.json();
    if (data.status && data.status >= 400) {
      throw new Error(data.description || data.message || 'Discount failed');
    }
    return data;
  }

  function codeApplied(cart, code) {
    const want = String(code || '').trim().toUpperCase();
    if (!want || !cart) return false;
    const list = cart.discount_codes || cart.cart_level_discount_applications || [];
    return list.some(function (d) {
      const name = String(d.code || d.title || '').toUpperCase();
      return name === want && d.applicable !== false;
    });
  }

  function applySections(sections) {
    if (!sections) return;
    const parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
    if (sections['cart-drawer']) {
      const doc = parse(sections['cart-drawer']);
      const inner = document.querySelector('cart-drawer .drawer__inner');
      const next = doc.querySelector('.drawer__inner') || doc.querySelector('#CartDrawer');
      if (inner && !next) throw new Error('Cart section unavailable');
      if (inner && next) inner.innerHTML = (next.querySelector('.drawer__inner') || next).innerHTML;
    }
    if (sections['cart-icon-bubble']) {
      const doc = parse(sections['cart-icon-bubble']);
      const cur = document.getElementById('cart-icon-bubble');
      const fresh = doc.getElementById('cart-icon-bubble') || doc.body.firstElementChild;
      if (cur && fresh) cur.innerHTML = fresh.innerHTML;
    }
    if (sections['main-cart-items']) {
      const doc = parse(sections['main-cart-items']);
      const page = document.getElementById('main-cart-items');
      const fresh = doc.getElementById('main-cart-items') || doc.querySelector('.shopify-section');
      if (page && fresh) page.innerHTML = fresh.innerHTML;
    }
    if (sections['main-cart-footer']) {
      const doc = parse(sections['main-cart-footer']);
      const page = document.getElementById('main-cart-footer');
      const fresh = doc.getElementById('main-cart-footer') || doc.querySelector('.shopify-section');
      if (page && fresh) page.innerHTML = fresh.innerHTML;
    }
  }

  function refreshCartUI(sectionsFromAdd, showDrawer = true) {
    if (sectionsFromAdd && typeof sectionsFromAdd['cart-drawer'] === 'string') {
      applySections(sectionsFromAdd);
      initCarousels();
      if (showDrawer) openCartDrawer();
      return Promise.resolve();
    }
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer')
      .then(function (r) { if (!r.ok) throw new Error('Cart section unavailable'); return r.json(); })
      .then(function (data) {
        if (document.querySelector('cart-drawer') && typeof data['cart-drawer'] !== 'string') throw new Error('Cart section unavailable');
        applySections(data);
        initCarousels();
        if (showDrawer) openCartDrawer();
      });
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  function shuffle(nodes) {
    const arr = Array.from(nodes);
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function initCarousel(el) {
      const track = el.querySelector('.lc-upsells__track');
      const dotsWrap = el.querySelector('[data-lc-dots]');
      if (!track || track.dataset.lcReady === 'true') return;
      track.dataset.lcReady = 'true';
      const ordered = shuffle(track.children);
      ordered.forEach(function (n) { track.appendChild(n); });
      const slides = Array.from(track.children);
      if (!slides.length) { el.style.display = 'none'; return; }
      el.dataset.lcIndex = '0';
      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.replaceChildren(...slides.map(function (_, i) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.i = String(i);
          button.classList.toggle('is-on', i === Number(el.dataset.lcIndex));
          button.setAttribute('aria-label', el.dataset.recommendationLabel + ' ' + (i + 1));
          button.setAttribute('aria-current', i === Number(el.dataset.lcIndex) ? 'true' : 'false');
          return button;
        }));
      }
      function go(n) {
        const index = (n + slides.length) % slides.length;
        el.dataset.lcIndex = String(index);
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        renderDots();
      }
      const prev = el.querySelector('[data-lc-prev]');
      const next = el.querySelector('[data-lc-next]');
      if (prev) prev.onclick = function () { go(Number(el.dataset.lcIndex) - 1); };
      if (next) next.onclick = function () { go(Number(el.dataset.lcIndex) + 1); };
      if (dotsWrap) dotsWrap.onclick = function (event) {
        const button = event.target.closest('button[data-i]');
        if (button) go(Number(button.dataset.i));
      };
      go(0);
  }

  function initCarousels() {
    document.querySelectorAll('[data-lc-carousel]').forEach(initCarousel);
  }

  if (!customElements.get('lc-upsell-carousel')) {
    customElements.define('lc-upsell-carousel', class extends HTMLElement {
      connectedCallback() { queueMicrotask(() => { if (this.isConnected) initCarousel(this); }); }
    });
  }

  function couponMsg(wrap, text, ok) {
    const el = wrap.querySelector('.lc-coupon__msg');
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
    el.classList.toggle('is-ok', !!ok);
    el.classList.toggle('is-err', !ok);
  }

  async function runCoupon(wrap, code) {
    const inDrawer = Boolean(wrap.closest('cart-drawer'));
    if (!wrap || !code) return;
    const btn = wrap.querySelector('[data-lc-coupon-apply]');
    if (btn) btn.disabled = true;
    couponMsg(wrap, wrap.dataset.applying, true);
    try {
      await applyDiscount(code);
      let after = await getCart();
      if (String(code).trim().toLowerCase() === 'lucky shipping') {
        await refreshCartUI(undefined, inDrawer);
        const freshWrap = inDrawer ? document.querySelector('cart-drawer [data-lc-coupon]') : document.querySelector('main [data-lc-coupon]');
        if (freshWrap) couponMsg(freshWrap, freshWrap.dataset.shippingCheck, true);
      } else if (codeApplied(after, code)) {
        await refreshCartUI(undefined, inDrawer);
      } else {
        couponMsg(wrap, wrap.dataset.codeError, false);
      }
    } catch (err) {
      couponMsg(wrap, wrap.dataset.codeError, false);
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-add]');
    if (!btn) return;
    const row = btn.closest('.lc-upsell');
    if (!row) return;
    e.preventDefault();
    if (upsellAdding || btn.disabled) return;
    const select = row.querySelector('.lc-upsell__variant');
    const id = select && select.value;
    if (!id || select.selectedOptions?.[0]?.disabled) return;
    const wrapper = row.closest('[data-lc-carousel]');
    const message = row.querySelector('[data-lc-upsell-error]');
    const label = btn.textContent;
    const controls = Array.from(document.querySelectorAll('.lc-upsell__add, .lc-upsell__variant'));
    const disabledStates = controls.map(control => control.disabled);
    upsellAdding = true;
    controls.forEach(control => { control.disabled = true; });
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = wrapper.dataset.addingLabel;
    if (message) { message.hidden = true; message.textContent = ''; }
    let accepted = false;
    try {
      const data = await addVariant(id, wrapper.dataset.addUncertain, wrapper.dataset.addRejected);
      accepted = true;
      await refreshCartUI(data && data.sections);
    } catch (error) {
      if (accepted) {
        window.location.assign(root + 'cart');
      } else if (message) {
        message.textContent = error.message || wrapper.dataset.addUncertain;
        message.hidden = false;
      }
    } finally {
      controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
      upsellAdding = false;
    }
  });

  document.addEventListener('change', function (event) {
    const select = event.target.closest('select.lc-upsell__variant');
    if (!select) return;
    const row = select.closest('.lc-upsell');
    const option = select.selectedOptions[0];
    if (!row || !option) return;
    const image = row.querySelector('.lc-upsell__img img');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    const price = row.querySelector('[data-lc-upsell-price]');
    const compare = row.querySelector('[data-lc-upsell-compare]');
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice; }
    row.querySelectorAll('[data-lc-product-link]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', select.value);
      link.href = url.href;
    });
    const button = row.querySelector('[data-add]');
    if (button) button.disabled = option.disabled;
    const message = row.querySelector('[data-lc-upsell-error]');
    if (message) { message.hidden = true; message.textContent = ''; }
  });

  document.addEventListener('click', function (e) {
    const applyBtn = e.target.closest('[data-lc-coupon-apply]');
    if (!applyBtn) return;
    e.preventDefault();
    const wrap = applyBtn.closest('[data-lc-coupon]');
    const input = wrap && wrap.querySelector('.lc-coupon__input');
    runCoupon(wrap, input && input.value.trim());
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    const input = e.target.closest('.lc-coupon__input');
    if (!input) return;
    e.preventDefault();
    runCoupon(input.closest('[data-lc-coupon]'), input.value.trim());
  });

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-lc-coupon-remove]');
    if (!btn) return;
    btn.disabled = true;
    try {
      await applyDiscount('');
      await refreshCartUI();
    } finally {
      btn.disabled = false;
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(initCarousels, 80); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();
